import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { getErrorMessages } from '../../../common/utils/error'
import { errorLogger } from '../../../common/utils/errorLogger'
import { AppDispatch, RootState } from '../../../store'
import { AxiosError, AxiosResponse } from 'axios'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { startLoading, stopLoading, LoadingTypes } from '@labrav/common'
import { camelize, snakeize } from 'casing'

import { shareWorkload } from '../../api/cloudfaas/wafr'
import { ShareWorkloadPayload } from './reducer'

export const SHARE_WORKLOAD_SUCCESS = 'SHARE_WORKLOAD_SUCCESS'

export const shareWorkloadWithUser =
  (
    partnerId: string,
    workloadId: string,
    shareWorkloadPayload: ShareWorkloadPayload,
    onSuccess?: (response: any) => void // optional callback
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const snakeCasePayload = snakeize(shareWorkloadPayload)

    await dispatch(startLoading(LoadingTypes.SHARE_WORKLOAD))
    try {
      const response = await shareWorkload(
        partnerId,
        workloadId,
        snakeCasePayload
      )

      if (response?.data) {
        const shareWorkloadResponse = camelize(response.data)
        dispatch({
          type: SHARE_WORKLOAD_SUCCESS,
          payload: shareWorkloadResponse,
        })
        if (onSuccess) {
          onSuccess(shareWorkloadResponse)
        }
      }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.SHARE_WORKLOAD))
    }
  }
